import { call, put, select, takeLeading } from "redux-saga/effects";
import { HistoryAPI } from "services/history";
import {
  getWithholdingTaxHistory,
  getWithholdingTaxHistorySuccess,
  getWithholdingTaxHistoryFailure,
} from "redux/reducers/history-withholding-tax";
import { HistorySelector } from "redux/selector/history-selector";
import { toPagingServer } from "utils/common-util";

function* getWithholdingTaxHistorySaga({ payload }) {
  try {
    const { isLoadMore, extend, year } = payload;
    const paginable = yield select(HistorySelector.WithholdingTax.paginable);
    const nextPage = isLoadMore ? { ...paginable, current: paginable.current + 1 } : paginable;

    const params = {
      ...toPagingServer(nextPage),
      year,
    };
    const response = yield call(HistoryAPI.WithholdingTax.getWithholdingTaxList, params);
    let histories = response.data.withholdingTaxHistList ?? [],
      total = response.data.total;
    histories.forEach((history) => {
      history.expandRef = `expanded-row-${history.substId}`; // for Desktop
      history.substIdDisplay = history.substId?.replace(/(\d{1})(\d{2})(\d{6})/, "$1-$2-$3");
    });
    if (extend) {
      const fetchedHistories = yield select(HistorySelector.WithholdingTax.histories);
      histories = [...fetchedHistories, ...histories];
    }
    yield put(getWithholdingTaxHistorySuccess({ histories, total, year, paginable: nextPage }));
  } catch (error) {
    console.error(error);
    yield put(getWithholdingTaxHistoryFailure(error));
  } finally {
    if (payload.unblockLoadMore) payload.unblockLoadMore();
  }
}

const saga = [takeLeading(getWithholdingTaxHistory, getWithholdingTaxHistorySaga)];

export default saga;
